import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { db, auth } from '../firebase';
import { doc, getDoc, updateDoc, collection, query, where, getDocs } from 'firebase/firestore';
import { sendPasswordResetEmail } from 'firebase/auth';
import { FaUser, FaSave, FaKey, FaChartLine, FaWhatsapp, FaBirthdayCake } from 'react-icons/fa';

export default function Profile() {
  const { userDetails, currentUser } = useAuth();
  const [loading, setLoading] = useState(true);
  
  // Estados de Edição
  const [name, setName] = useState('');
  const [phone, setPhone] = useState('');
  const [birthDate, setBirthDate] = useState(''); // NOVO CAMPO
  const [stats, setStats] = useState({ count: 0, nextDate: '' });

  useEffect(() => {
    const fetchData = async () => {
      if (!userDetails?.musicianId) return;

      try {
        // 1. Buscar dados do músico
        const musDoc = await getDoc(doc(db, "musicians", userDetails.musicianId));
        if (musDoc.exists()) {
          const data = musDoc.data();
          setName(data.name);
          setPhone(data.phone || '');
          setBirthDate(data.birthDate || ''); // Carrega data
        }

        // 2. Calcular Estatísticas
        const today = new Date();
        const firstDay = new Date(today.getFullYear(), today.getMonth(), 1).toISOString().split('T')[0];
        const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0).toISOString().split('T')[0];
        
        const schedulesRef = collection(db, "schedules");
        const q = query(schedulesRef, where("date", ">=", firstDay), where("date", "<=", lastDay));
        const snap = await getDocs(q);
        
        let count = 0;
        let nextDate = null;

        snap.forEach(doc => {
            const sched = doc.data();
            if (sched.team && sched.team.some(m => m.id === userDetails.musicianId)) {
                count++;
                if (sched.date >= new Date().toISOString().split('T')[0]) {
                    if (!nextDate || sched.date < nextDate) nextDate = sched.date;
                }
            }
        });

        setStats({ count, nextDate });

      } catch (error) {
        console.error("Erro ao carregar perfil:", error);
      }
      setLoading(false);
    };

    fetchData();
  }, [userDetails]);

  const handleSave = async (e) => {
    e.preventDefault();
    if (!name) return alert("O nome é obrigatório.");

    try {
      // Atualiza na coleção 'musicians'
      await updateDoc(doc(db, "musicians", userDetails.musicianId), {
        name,
        phone,
        birthDate, // Salva data
        updatedAt: new Date()
      });

      // Atualiza na coleção de permissões 'app_users'
      await updateDoc(doc(db, "app_users", currentUser.email), {
        musicianName: name
      });

      alert("Perfil atualizado com sucesso!");
    } catch (error) {
      console.error("Erro ao salvar:", error);
      alert("Erro ao atualizar perfil.");
    }
  };

  const handlePasswordReset = async () => {
    if (window.confirm(`Enviar link para redefinir senha para ${currentUser.email}?`)) {
        try {
            await sendPasswordResetEmail(auth, currentUser.email);
            alert("E-mail enviado! Verifique sua caixa de entrada (e spam).");
        } catch (error) {
            alert("Erro: " + error.message);
        }
    }
  };

  const handlePhoneChange = (e) => {
    let value = e.target.value.replace(/\D/g, '');
    if (value.length > 11) value = value.slice(0, 11);
    if (value.length > 10) { value = value.replace(/^(\d{2})(\d{5})(\d{4})/, '($1) $2-$3'); } 
    else if (value.length > 6) { value = value.replace(/^(\d{2})(\d{4})(\d{0,4})/, '($1) $2-$3'); } 
    else if (value.length > 2) { value = value.replace(/^(\d{2})(\d{0,5})/, '($1) $2'); }
    setPhone(value);
  };

  // Função para formatar data visualmente
  const formatDateDisplay = (dateString) => {
      if(!dateString) return '';
      const [y, m, d] = dateString.split('-');
      return `${d}/${m}/${y}`;
  }

  if (loading) return <div className="p-10 text-center">Carregando perfil...</div>;

  return (
    <div className="max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold text-gray-800 mb-6">Meu Perfil</h1>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        
        {/* COLUNA 1: CARTÃO DE USUÁRIO */}
        <div className="md:col-span-1">
            <div className="bg-white rounded-lg shadow p-6 text-center border-t-4 border-brand-blue">
                <div className="w-20 h-20 bg-brand-blue rounded-full mx-auto flex items-center justify-center text-white text-3xl mb-4">
                    <FaUser />
                </div>
                <h2 className="text-xl font-bold text-gray-800">{name}</h2>
                <p className="text-sm text-gray-500 mb-2">{currentUser.email}</p>
                
                {/* Exibe Data de Nascimento se tiver */}
                {birthDate && (
                    <p className="text-sm text-brand-blue flex items-center justify-center gap-2 mb-4">
                        <FaBirthdayCake /> {formatDateDisplay(birthDate)}
                    </p>
                )}
                
                {/* CARD "SUAS FUNÇÕES" FOI REMOVIDO DAQUI CONFORME SOLICITADO */}
            </div>
            
            {/* ESTATÍSTICAS */}
            <div className="bg-white rounded-lg shadow p-4 mt-4 border-l-4 border-brand-gold">
                <div className="flex items-center gap-3 mb-2">
                    <FaChartLine className="text-brand-gold text-xl" />
                    <h3 className="font-bold text-gray-700">Estatísticas (Mês)</h3>
                </div>
                <div className="flex justify-between items-end">
                    <div>
                        <span className="text-3xl font-bold text-brand-blue">{stats.count}</span>
                        <span className="text-xs text-gray-500 ml-1">escalas</span>
                    </div>
                    {stats.nextDate && (
                        <div className="text-right">
                            <p className="text-[10px] text-gray-400">Próxima:</p>
                            <p className="text-xs font-bold text-green-600">
                                {new Date(stats.nextDate).toLocaleDateString('pt-BR', {day:'2-digit', month:'2-digit'})}
                            </p>
                        </div>
                    )}
                </div>
            </div>
        </div>

        {/* COLUNA 2: FORMULÁRIO DE EDIÇÃO */}
        <div className="md:col-span-2">
            <div className="bg-white rounded-lg shadow p-6">
                <h3 className="text-lg font-bold text-gray-700 mb-4 border-b pb-2">Editar Dados</h3>
                
                <form onSubmit={handleSave} className="space-y-4">
                    <div>
                        <label className="block text-sm font-bold text-gray-600 mb-1">Nome Completo</label>
                        <input 
                            value={name} 
                            onChange={(e) => setName(e.target.value)} 
                            className="w-full border p-2 rounded focus:border-brand-blue outline-none"
                        />
                    </div>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <div>
                            <label className="block text-sm font-bold text-gray-600 mb-1">WhatsApp</label>
                            <div className="flex items-center border rounded bg-white focus-within:border-brand-blue">
                                <span className="p-2 text-green-500"><FaWhatsapp /></span>
                                <input 
                                    value={phone} 
                                    onChange={handlePhoneChange} 
                                    className="w-full p-2 outline-none"
                                    placeholder="(00) 00000-0000"
                                />
                            </div>
                        </div>
                        
                        {/* NOVO CAMPO DATA DE NASCIMENTO */}
                        <div>
                            <label className="block text-sm font-bold text-gray-600 mb-1">Data de Nascimento</label>
                            <input 
                                type="date"
                                value={birthDate} 
                                onChange={(e) => setBirthDate(e.target.value)} 
                                className="w-full border p-2 rounded focus:border-brand-blue outline-none"
                            />
                        </div>
                    </div>

                    <div className="pt-4">
                        <button type="submit" className="bg-brand-blue text-white px-6 py-2 rounded font-bold hover:bg-blue-800 transition flex items-center gap-2">
                            <FaSave /> Salvar Alterações
                        </button>
                    </div>
                </form>
            </div>

            {/* SEGURANÇA */}
            <div className="bg-white rounded-lg shadow p-6 mt-6">
                <h3 className="text-lg font-bold text-gray-700 mb-4 border-b pb-2 flex items-center gap-2">
                    <FaKey className="text-brand-gold"/> Segurança
                </h3>
                
                <div className="flex items-center justify-between">
                    <div>
                        <p className="font-bold text-gray-800">Senha</p>
                        <p className="text-sm text-gray-500">Você receberá um e-mail seguro para criar uma nova senha.</p>
                    </div>
                    <button 
                        onClick={handlePasswordReset}
                        className="border border-gray-300 text-gray-600 px-4 py-2 rounded hover:bg-gray-50 text-sm font-bold transition"
                    >
                        Redefinir Senha
                    </button>
                </div>
            </div>
        </div>

      </div>
    </div>
  );
}